export const QUESTION_COUNTER_HEIGHT = 44;
export const SIMPLE_VOICE_ASSISTANT_HEIGHT_REALTIME = 140;
export const SIMPLE_VOICE_ASSISTANT_HEIGHT_TURN_BASED = 200;
export const ASSESSMENT_MENU_HEIGHT = 52;
export const ASSESSMENT_MENU_HEIGHT_MOBILE = 156;
export const BOTTOM_SPACING_HEIGHT = 20;
export const CONTENT_CONTAINER_PADDING = 20;
export const ASSESSMENT_INTRO_DISPLAY_HEIGHT = 100;
